
export default {
  computed: {
    cmsPageId: function () {
      return this.$store.state.appState?.vars?.['ID CMS страницы 404'];
    },
  },
};
